import { LEAVE_CAP_UNITS } from '@sdk/common/constants';
import validateNumber, {
  ValidateOptions,
  ValidNumberOption,
} from '@sdk/utils/validation/validateNumber';

export const getLeaveCapFormat = (leaveCapUnit: string): string => {
  return LEAVE_CAP_UNITS.find((unit) => leaveCapUnit === unit.value).label;
};

export const getWorkDayHours = (workDayMinutes: number): number => {
  return workDayMinutes / 60;
};

export const setWorkDayHours = (value: number | string): number => {
  return Number(value) * 60;
};

export const setZeroEmpty = (value: number | string): string | number => {
  return value === 0 || value === '0' ? '' : value;
};

export const getZeroEmpty = (value: number | string): number | string => {
  return value === '' ? 0 : value;
};

export const validateDayCapped = (value: number | string): boolean => {
  return validateNumber(value, {
    [ValidateOptions.integer]: true,
    [ValidateOptions.validNumber]: ValidNumberOption.nonNegative,
  });
};

export const validateWorkDayHours = (value: number | string): boolean => {
  return validateNumber(value, {
    [ValidateOptions.integer]: true,
    [ValidateOptions.validNumber]: ValidNumberOption.positive,
    [ValidateOptions.validNumberLowerOrEqualThan]: 24,
  });
};
